const KEY = "wiswiz_attribution";
const FIELDS = ["utm_source", "utm_campaign", "utm_content", "fbclid", "mailing_id"] as const;
export type Attribution = Partial<Record<(typeof FIELDS)[number], string>>;
function normalize(value: unknown): Attribution {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const input = value as Record<string, unknown>;
  const result: Attribution = {};
  for (const key of FIELDS) if (typeof input[key] === "string" && input[key].length > 0) result[key] = input[key].slice(0, 256);
  return result;
}
export function rememberAttribution(search?: string): Attribution {
  if (typeof window === "undefined") return {};
  let current: Attribution = {};
  try { current = normalize(JSON.parse(localStorage.getItem(KEY) || "{}")); } catch {}
  const p = new URLSearchParams(search ?? window.location.search);
  for (const key of FIELDS) { const value = p.get(key); if (value) current[key] = value.slice(0, 256); }
  try { localStorage.setItem(KEY, JSON.stringify(current)); } catch {}
  return current;
}
export function readAttribution(): Attribution {
  if (typeof window === "undefined") return {};
  try { return normalize(JSON.parse(localStorage.getItem(KEY) || "{}")); } catch { return {}; }
}

export function attributionStatus(value: Attribution = readAttribution()): "attributed" | "unknown" { return Object.keys(value).length ? "attributed" : "unknown"; }
